export default __webpack_public_path__ + "static/media/b33f0b64-fa93-4f15-8c94-21ceb4ce722b.11edd399.jpeg";